import API from '@/api';
const Password = API.get('Password');

export default ({
  namespaced: true,
  state: {
		// password_reset_code: '',
    // email: '',
    // new_password: '',
    // new_password_confirmation: ''
  },
  getters: {
		// password_reset_code: state => state.password_reset_code,
    // email: state => state.email,
    // new_password: state => state.new_password,
    // new_password_confirmation: state => state.new_password_confirmation
  },
  mutations: {
		// setPasswordResetCode(state, value) {
    //   state.password_reset_code = value
    // },
    // setEmail(state, value) {
    //   state.email = value
    // },
    // setNewPassword(state, value) {
    //   state.new_password = value
    // },
    // setNewPasswordConfirmation(state, value) {
    //   state.new_password_confirmation = value
    // }
  },
  actions: {
    async reset(state, {email}) {
			let response = await Password.reset(email);
			console.log('[password/reset]', response)
      return response
		},
    async change(state, {code, email, pass, pass_confirm}) {
      const payload = {
        password_reset_code: code,
        email: email,
        new_password: pass,
        new_password_confirmation: pass_confirm
      }
			let response = await Password.change(payload);
			console.log('[password/change]', response)
      return response
		}
  }
})